import {Validator} from "vee-validate";
import {
    validateCheckedAny,
    validateCheckedValue,
    validateRequiredProperty,
    validateRequiredValue
} from "@/validation/validation";
import {isValueSet} from "@/common/format";

Validator.extend('greater_than', {
    validate: (value, args) => {
        let otherValue = args[0];
        return isValueSet(otherValue) ? value > otherValue : true;
    }
}, {
    hasTarget: true
});

Validator.extend('less_than', {
    validate: (value, args) => {
        let otherValue = args[0];
        return isValueSet(otherValue) ? value < otherValue : true;
    }
}, {
    hasTarget: true
});

Validator.extend('checked', {
    validate: (value) => {
        return {
            valid: validateCheckedValue(value),
            data: {
                required: false
            }
        };
    }
}, {
    computesRequired: true
});

Validator.extend('is_percentage_rate', {
    validate: (value) => {
        return {
            valid: typeof value === "number" && value >= 0 && value <= 1,
        };
    }
});

Validator.extend('required_property', {
    validate: (value, args) => {
        let requiredPropertyKey = args["name"];
        return {
            valid: validateRequiredProperty(value, requiredPropertyKey),
            data: {
                required: false
            }
        };
    }
}, {
    computesRequired: true,
    paramNames: ["name"]
});

Validator.extend('required_if_func', {
    validate: (value, args) => {
        let isRequiredFunc = args["func"];
        return {
            valid: validateRequiredValue(value),
            data: {
                required: isRequiredFunc(value)
            }
        };
    }
}, {
    computesRequired: true,
    paramNames: ["func"]
});

Validator.extend('checked_any', {
    validate: (value, args) => {
        const isValid = validateCheckedAny(args["conditionFunc"]?.(), args["fieldNames"], args["dataGetter"]());

        // Check if the condition is met for required flag
        const isConditionMet = args["conditionFunc"]?.();

        return {
            valid: isValid,
            data: {
                required: isConditionMet
            }
        };
    }
}, {
    computesRequired: true,
    paramNames: ["conditionFunc", "fieldNames", "dataGetter"]
});

Validator.extend('async', {
    getMessage: (field, params, data) => {
        // This sadly does not work with i18n activated and the current vee-validate version.
        // So for now we just pipe the msg parameter to the translation
    },
    validate: (value, args) => {
        return new Promise(resolve => {
            args["api"]()
                .then(() => resolve({ valid: true }))
                .catch(() => resolve({ valid: false }))
        });
    },
}, {
    paramNames: ["api", "msg"]
});

Validator.extend('deprecated', {
    validate: (value, args) => {
        let useFieldAccess = args.hasOwnProperty("field");
        let useValueGetter = args.hasOwnProperty("valueGetter");

        function isDeprecated(value) {
            if (useValueGetter) {
                return args["valueGetter"](value);
            } else if (useFieldAccess) {
                let deprecatedPropertyKey = args["field"];
                return value.hasOwnProperty(deprecatedPropertyKey) && value[deprecatedPropertyKey];
            }

            return false;
        }

        let valid;
        if (value instanceof Array) {
            valid = !value.some(isDeprecated);
        } else if (value instanceof Object) {
            valid = isDeprecated(value);
        } else {
            valid = true;
        }

        return {
            valid: valid
        };
    }
}, {
    paramNames: ["field", "valueGetter"]
});